import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { chessUiMultiplayerCursors } from '../ui/chessUiMultiplayerCursors-sidecar'
import { EChessMessage } from './chessMessageIds'

export interface IChessMessageCursorPick {
  pieceId: number
  command: EChessCursorPickCommand
}

export enum EChessCursorPickCommand {
  Pickup = 1,
  Putdown = 2,
}

export const messageId = EChessMessage.CursorPick

export function write(m: IMessageWriter, d: IChessMessageCursorPick) {
  messageWriter.write8(m, messageId)
  messageWriter.write32(m, d.pieceId)
  messageWriter.write8(m, d.command)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, messageId)
  let d: IChessMessageCursorPick = {
    pieceId: messageWriter.read32(m),
    command: messageWriter.read8(m),
  }
  return d
}

export function test() {
  let ex: IChessMessageCursorPick = {
    pieceId: 256,
    command: EChessCursorPickCommand.Putdown,
  }
  messageWriter.test('cursor pick', ex, write, read)
}

export function process(
  m: IMessageWriter,
  isFromHost: boolean,
  fromId: number,
) {
  let msg = read(m)
  let cur = chessUiMultiplayerCursors.findByMultiIdSafe(fromId)
  if (cur) {
    chessUiMultiplayerCursors.networkRecievePick(cur, msg.pieceId, msg.command)
  }
}

export function sendMessageToOthers(msg: IChessMessageCursorPick) {
  websockets._sendMessageToOthers(write, msg)
}
